import axios from "axios";
import Cookies from "js-cookie";

const authInterceptor = (config) => {
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get("token");

  const tokenFromCookie = Cookies.get("halasat-ftth-token-1");

  const token = tokenFromUrl || tokenFromCookie;

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  config.headers["Content-Type"] = "application/json";
  config.headers["app-version"] = "1.3";

  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // eslint-disable-next-line default-case
    switch (error.response.status) {
      case 401:
        window.location.href = "/login";
        break;
    }
    return Promise.reject(error);
  }
);
export default api;
